import { render, staticRenderFns } from "./CurvePage.vue?vue&type=template&id=427561fc&scoped=true&"
import script from "./CurvePage.vue?vue&type=script&lang=js&"
export * from "./CurvePage.vue?vue&type=script&lang=js&"
import style0 from "./CurvePage.vue?vue&type=style&index=0&id=427561fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427561fc",
  null
  
)

export default component.exports